import MatchDetails from './MatchDetails'
import Commentary from './Commentary'
import Coverage from './Coverage'
import Innings from './Innings'
import InningsSummary from './InningsSummary'
import MatchNotes from './MatchNotes'
import Statistics from './Statistics'
import ScorecardSummary from './ScorecardSummary'
import { SquadTabs, SquadModule } from './Squad'
import getAppView from './getAppView'
import CommentaryFeedback from './CommentaryFeedback'
import Article from './Article'
import HawkEye from './HawkEye'
import CloseOfPlay from './CloseOfPlay'
import Scorers from './Scorers'

export { MatchDetails }
export { Commentary }
export { Coverage }
export { Innings }
export { InningsSummary }
export { MatchNotes }
export { Statistics }
export { ScorecardSummary }
export { SquadTabs }
export { SquadModule }
export { getAppView }
export { CommentaryFeedback }
export { Article }
export { HawkEye }
export { CloseOfPlay }
export { Scorers }

export default{
  MatchDetails,
  Commentary,
  Coverage,
  Innings,
  InningsSummary,
  MatchNotes,
  Statistics,
  ScorecardSummary,
  SquadTabs,
  SquadModule,
  getAppView,
  CommentaryFeedback,
  Article,
  HawkEye,
  CloseOfPlay,
  Scorers
}



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/index.js
 **/